import { render, staticRenderFns } from "./PriceProfitabilityChart.vue?vue&type=template&id=3d01c980&scoped=true&"
import script from "./PriceProfitabilityChart.vue?vue&type=script&lang=js&"
export * from "./PriceProfitabilityChart.vue?vue&type=script&lang=js&"
import style0 from "./PriceProfitabilityChart.vue?vue&type=style&index=0&id=3d01c980&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d01c980",
  null
  
)

/* custom blocks */
import block0 from "./PriceProfitabilityChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressCircular,VTooltip})
